export const state = {
    profileInfo: {},
    GetPaymentMethods: [],
    notificationList: { 'totalRecords': 0, 'records': [] },
    notificationUnreadList: { 'totalRecords': 0, 'records': [] },
    notificationEnablegetSettings: [],
    notificationGetSettings: [],
    bankAddresses: { 'totalRecords': 0, 'records': [] },
    cryptoAddresses: { 'totalRecords': 0, 'records': [] },
    refreshData: '0',
    watchListData:[],
    newsList : [],
    cryptoNewsList : [],
}


// WEBPACK FOOTER //
// ./src/plugins/commonAll/provider/store-addons/state.js